import { setCookie, getCookie } from "@/services/cookies";

/**
 * Stores info about login in browser.
 * We can detect if someone was already logged in in this exact browser.
 */
export const LoginMarkerService = {
  CookieName: "dsr_swli",

  markLogin: (): void => {
    const expiration = new Date();
    expiration.setFullYear(expiration.getFullYear() + 1);
    setCookie(LoginMarkerService.CookieName, "1", expiration.toUTCString(), "/");
  },

  wasSomeoneEverLoggedIn: (): boolean => {
    const cookie = getCookie(LoginMarkerService.CookieName);
    return cookie !== null;
  },
};
